import { type ListingProduct, ListingProductCode } from 'src/generated/graphql';

import type { DesktopFeatures } from '../desktop';
import type { MobileFeatures } from '../mobile';

type ListingPackageInfo = {
  productCode: ListingProduct['productCode'];
  description: string;
  features: {
    desktop: DesktopFeatures;
    mobile: MobileFeatures;
  };
};

export const listingProducts: ListingPackageInfo[] = [
  {
    productCode: ListingProductCode.Freemium,
    description: 'Starting your selling journey',
    features: {
      desktop: {
        duration: '6month',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'disabled',
        searchRank: 'disabled',
        boostedEmail: 'disabled',
        featuredSearch: 'disabled',
        featuredEmail: 'disabled',
      },
      mobile: {
        duration: { enabled: true, label: '6 months' },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
  {
    productCode: ListingProductCode.ListUntilSold,
    description: 'Get noticed by more buyers',
    features: {
      desktop: {
        duration: 'lus',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'enabled',
        searchRank: 'enabled',
        boostedEmail: 'disabled',
        featuredSearch: 'disabled',
        featuredEmail: 'disabled',
      },
      mobile: {
        duration: { enabled: true },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
  {
    productCode: ListingProductCode.Accelerate,
    description: 'Reach the right buyers faster',
    features: {
      desktop: {
        duration: 'lus',
        listing: 'enabled',
        connections: 'enabled',
        photo: 'enabled',
        searchRank: 'enabled',
        boostedEmail: 'enabled',
        featuredSearch: 'enabled',
        featuredEmail: 'enabled',
      },
      mobile: {
        duration: { enabled: true },
        listing: { enabled: true },
        connections: { enabled: true },
        photo: { enabled: true },
        searchRank: { enabled: true },
        boostedEmail: { enabled: true },
        featuredSearch: { enabled: true },
        featuredEmail: { enabled: true },
      },
    },
  },
] satisfies ListingPackageInfo[];

export interface ListingProductWithPackageInfo extends ListingProduct {
  productCode: (typeof listingProducts)[number]['productCode'];
}

export const hasProductInfo = (
  listingProduct: ListingProduct,
): listingProduct is ListingProductWithPackageInfo =>
  listingProducts.some(
    (x) => listingProduct && x.productCode === listingProduct.productCode,
  );

export const getProductInfo = (listingProduct: ListingProductWithPackageInfo) =>
  listingProducts.find((x) => x.productCode === listingProduct.productCode)!;
